import OTPVerificationForm from './OTPVerificationForm';

export default OTPVerificationForm;
